<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 502 502"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M466.054,412.976c-2.4-6-8.16-9.952-14.608-10.064c-82.336-1.344-149.312-69.408-149.312-151.728 c0-82.336,66.976-150.4,149.28-151.744c6.464-0.112,12.224-4.08,14.608-10.064c2.384-5.984,0.96-12.816-3.648-17.344 C415.11,25.584,352.598,0,286.358,0C147.846,0,35.174,112.672,35.174,251.184s112.672,251.184,251.184,251.184 c66.24,0,128.768-25.584,176.048-72.048C467.014,425.808,468.438,418.96,466.054,412.976z M286.358,470.368 c-120.848,0-219.184-98.32-219.184-219.184S165.51,32,286.358,32c45.856,0,89.68,14.048,126.432,40.112 c-81.44,18.88-142.672,92.464-142.672,179.072S331.35,411.36,412.79,430.24C376.038,456.304,332.23,470.368,286.358,470.368z"
        />
      </g>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  &:hover {
      border-radius: 10px;
    }
  path {
    fill: var(--theme-toggle-bg);
  }
}
</style>
